
export default {
  name: "faq-item",
  props: ["faq", "index", "open"],
};
